module.exports = __webpack_public_path__ + "img/thumbnail_GreySeal_j_albino.5da3d32d.png";